import React from 'react';
import { useNavigate } from 'react-router-dom';
import SharedHeader from '../../../../components/SharedHeader';
import DashboardFooter from '../../../../components/DashboardFooter';
import UnderConstruction from '../../../../components/UnderConstruction';
import './activity_analytics.css';

const ActivityAnalytics = () => {
  const navigate = useNavigate();

  return (
    <div className="actv_altc_admin-page">
      <SharedHeader />
      
      <main className="actv_altc_admin-content">
        <div className="actv_altc_admin-header">
          <button 
            className="actv_altc_back-button"
            onClick={() => navigate('/admin/analytics')}
          >
            <i className="fas fa-arrow-left"></i> Back to Analytics
          </button>
          <h1>Activity Analytics</h1>
        </div>

        <UnderConstruction pageName="Activity Analytics" />
      </main>

      <DashboardFooter />
    </div>
  );
};

export default ActivityAnalytics; 